import React from 'react';
import { BookIcon, TagIcon, UsersIcon, HeadphonesIcon, ShoppingBagIcon, CalendarIcon, BookOpenIcon, HeartIcon, ClipboardListIcon, StarIcon, HomeIcon, TrendingUpIcon, LibraryIcon, BookmarkIcon, MessageSquareIcon, SearchIcon, TrophyIcon, PenToolIcon, ImageIcon, PackageIcon, MapPinIcon, StoreIcon, HeartHandshakeIcon, AlertCircleIcon, FlameIcon, UserIcon, BellIcon, LayoutGridIcon, ZapIcon, LinkIcon, GlobeIcon, CompassIcon, SparklesIcon, LayersIcon, BuildingIcon } from 'lucide-react';
import { MenuSection } from './types';
export const readerMenuSections: MenuSection[] = [{
  id: 'home',
  label: 'Home',
  icon: <HomeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2488" data-mp="2cq91i7tqu7ji" />,
  to: '/'
}, {
  id: 'browse',
  label: 'Browse Books',
  icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2489" data-mp="fwnv4vmxek0m" />,
  children: [{
    label: 'All Books',
    to: '/browse',
    icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2490" data-mp="awt7d0yg6ajs" />
  }, {
    label: 'New Releases',
    to: '/new-books',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2491" data-mp="2615urihoehw" />
  }, {
    label: 'Bestsellers',
    to: '/bestsellers',
    icon: <TrendingUpIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2492" data-mp="3kd8fmwe6htjn" />
  }, {
    label: 'Series',
    to: '/series',
    icon: <LibraryIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2493" data-mp="guxcql8t7lgx" />
  }, {
    label: 'Anthologies',
    to: '/anthologies',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2494" data-mp="lsgrrndc029x" />
  }, {
    label: 'Book Graphics',
    to: '/books/graphics',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2495" data-mp="c3yrr8cvlz7c" />
  }]
}, {
  id: 'discover',
  label: 'Discover',
  icon: <CompassIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2496" data-mp="zt9jk0c90j9c" />,
  children: [{
    label: 'Story Galaxy',
    to: '/story-galaxy',
    icon: <SparklesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2497" data-mp="14m2rex30k7pn" />
  }, {
    label: 'Story Stack',
    to: '/story-stack',
    icon: <LayersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2498" data-mp="19gvq3g3sogo4" />
  }, {
    label: 'Book Discovery',
    to: '/discover',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2499" data-mp="14k5aetvwjn38" />
  }]
}, {
  id: 'genres',
  label: 'Browse by Genre',
  icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2500" data-mp="vh47f22c2c3s" />,
  to: '/genres'
}, {
  id: 'content',
  label: 'Content',
  icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2501" data-mp="qpmcovqwl7r9" />,
  children: [{
    label: 'All Content Tags',
    to: '/all-content-tags',
    icon: <LayoutGridIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2502" data-mp="gsrhalpxfnh7" />
  }, {
    label: 'Tropes',
    to: '/tropes',
    icon: <HeartHandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2503" data-mp="cpl2gpor0nz4" />
  }, {
    label: 'Characters',
    to: '/characters',
    icon: <UserIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2504" data-mp="2jf5814w91c0k" />
  }, {
    label: 'Relationship Types',
    to: '/relationship-types',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2505" data-mp="2ocwwfoxoqg00" />
  }, {
    label: 'Pairing Types',
    to: '/pairing-types',
    icon: <LinkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2506" data-mp="2xextolsx521o" />
  }, {
    label: 'Spice & Darkness',
    to: '/spice-darkness',
    icon: <FlameIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2507" data-mp="20pyk93gllu7w" />
  }, {
    label: 'Burn Levels',
    to: '/burn-levels',
    icon: <ZapIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2508" data-mp="24nw8o42joca8" />
  }, {
    label: 'Ending Types',
    to: '/ending-types',
    icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2509" data-mp="2egbwhi0ivv31" />
  }, {
    label: 'Representation',
    to: '/representation',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2510" data-mp="1gytvp9iuv7m2" />
  }, {
    label: 'Cultural Identity',
    to: '/cultural-identity',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2511" data-mp="3onhj5u531npd" />
  }, {
    label: 'Themes',
    to: '/themes',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2512" data-mp="3jp66lbnekz3g" />
  }, {
    label: 'Book Settings',
    to: '/settings',
    icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2513" data-mp="3snhvn98mfots" />
  }, {
    label: 'Content Warnings',
    to: '/content-warnings',
    icon: <AlertCircleIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2514" data-mp="b5p18ayknpe0" />
  }]
}, {
  id: 'authors',
  label: 'Explore Authors',
  icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2515" data-mp="k8q5e63vn6f1" />,
  children: [{
    label: 'All Authors',
    to: '/authors',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2516" data-mp="g74n258kpzxg" />
  }, {
    label: 'New Authors',
    to: '/authors/new',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2517" data-mp="2hy998lrqm8ae" />
  }, {
    label: 'Award Winners',
    to: '/authors?filter=award-winners',
    icon: <TrophyIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2518" data-mp="27uuih0s3ze7b" />
  }, {
    label: 'Browse by Genre',
    to: '/authors?filter=by-genre',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2519" data-mp="1y518u5bj195p" />
  }]
}, {
  id: 'audio',
  label: 'Audiobooks',
  icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2520" data-mp="231rmklzuzsny" />,
  children: [{
    label: 'All Audiobooks',
    to: '/audiobooks',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2521" data-mp="1t4wmhynxtk7k" />
  }, {
    label: 'Genres',
    to: '/audiobooks/genres',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2522" data-mp="1f6ydz9washzz" />
  }, {
    label: 'Audiobook Graphics',
    to: '/audiobooks/graphics',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2523" data-mp="39iva3g5oqc1d" />
  }, {
    label: 'Audiobook Discovery',
    to: '/audiobooks/discovery',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2524" data-mp="3egexb5kd1z5g" />
  }, {
    label: 'New Releases',
    to: '/audiobooks/new',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2525" data-mp="381zmzuajcwr1" />
  }, {
    label: 'Bestsellers',
    to: '/audiobooks/bestsellers',
    icon: <TrendingUpIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2526" data-mp="3358w0bx70gqu" />
  }, {
    label: 'Series',
    to: '/audiobooks/series',
    icon: <LibraryIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2527" data-mp="3vs3cyyuswxzk" />
  }, {
    label: 'Browse Narrators',
    to: '/narrators',
    icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2528" data-mp="3quts7wicxai2" />
  }]
}, {
  id: 'trove',
  label: 'Trove',
  icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2529" data-mp="3h2xg3hjfrjuu" />,
  children: [{
    label: 'All Articles & News',
    to: '/trove',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2530" data-mp="iei5ptbka6fw" />
  }, {
    label: 'Trove Updates',
    to: '/trove/updates',
    icon: <BellIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2531" data-mp="kxlj5u6rlwh2" />
  }, {
    label: 'Awards & Recognition',
    to: '/trove#awards',
    icon: <TrophyIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2532" data-mp="pwygj8v9ilxw" />
  }, {
    label: 'Genre Spotlights',
    to: '/trove/genres',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2533" data-mp="zucmufnh1uch" />
  }, {
    label: 'Audio & Narration',
    to: '/trove/audio',
    icon: <HeadphonesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2534" data-mp="13voe0plzunms" />
  }, {
    label: 'Industry Events',
    to: '/trove/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2535" data-mp="1dmapc7mogrzo" />
  }, {
    label: 'Got a Story Stuck in Your Head?',
    to: '/trove/story-in-your-head',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2536" data-mp="1imybofzyoknk" />
  }]
}, {
  id: 'merch',
  label: 'Book Boxes & Merch',
  icon: <ShoppingBagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2537" data-mp="1rl0n7phbmvp3" />,
  children: [{
    label: 'Merch Business Profiles',
    to: '/merch-business-profiles',
    icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2538" data-mp="28vf6kbfus6fi" />
  }, {
    label: 'Book Boxes',
    to: '/book-boxes',
    icon: <PackageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2539" data-mp="2mtlouj8bjxu2" />
  }, {
    label: 'Clothing',
    to: '/merch/clothing',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2540" data-mp="1u68yrz2y97w0" />
  }, {
    label: 'Accessories',
    to: '/merch/accessories',
    icon: <TagIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2541" data-mp="1p87jzqck3uqc" />
  }, {
    label: 'Art Prints',
    to: '/merch/art-prints',
    icon: <ImageIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2542" data-mp="23xvk4o904nch" />
  }, {
    label: 'Home & Living',
    to: '/merch/home-living',
    icon: <HomeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2543" data-mp="1bepyw14829y7" />
  }]
}, {
  id: 'bookstores',
  label: 'Bookstores',
  icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2544" data-mp="16geq7tpny5hk" />,
  children: [{
    label: 'Browse All Bookstores',
    to: '/bookstores',
    icon: <StoreIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2545" data-mp="3mv0alvrz34ve" />
  }, {
    label: 'Brick & Mortar',
    to: '/bookstores?type=brick-and-mortar',
    icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2546" data-mp="3d4x5wybho2h8" />
  }, {
    label: 'Online Stores',
    to: '/bookstores?type=online-only',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2547" data-mp="4pn6jxyzhbd5" />
  }, {
    label: 'Signed Copies',
    to: '/bookstores?feature=signedCopies',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2548" data-mp="3rumlhykbw911" />
  }]
}, {
  id: 'events',
  label: 'Events',
  icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2549" data-mp="lyxtbym89qb" />,
  children: [{
    label: 'View All Events',
    to: '/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2550" data-mp="2ldhmfd58avv8" />
  }, {
    label: 'Author Events',
    icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2551" data-mp="1qkeich0zud9x" />,
    children: [{
      label: 'Book Signings',
      to: '/events/book-signings',
      icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2552" data-mp="1gv382r2df2kg" />
    }, {
      label: 'Book Launches',
      to: '/events/book-launches',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2553" data-mp="1lrlbnnlysuv7" />
    }, {
      label: 'Author Talks',
      to: '/events/author-talks',
      icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2554" data-mp="1bxbii3p77sjf" />
    }, {
      label: 'Author Panels',
      to: '/events/author-panels',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2555" data-mp="12w3ldoyf4xqx" />
    }, {
      label: 'Multi-Author Signings',
      to: '/events/multi-author-signings',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2556" data-mp="2x9d0bw9qhbgk" />
    }]
  }, {
    label: 'Reader Community',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2557" data-mp="37axfwunw7rsr" />,
    children: [{
      label: 'Local Author Events',
      to: '/events/local-authors',
      icon: <MapPinIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2558" data-mp="3g6wmmdzfy55i" />
    }, {
      label: 'Reading Meetups',
      to: '/events/reading-meetups',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2559" data-mp="3q2gk34tnlbwd" />
    }, {
      label: 'Book Swaps',
      to: '/events/book-swaps',
      icon: <HeartHandshakeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2560" data-mp="2yjs512ifwj4" />
    }]
  }, {
    label: 'Book Clubs',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2561" data-mp="3v3477ferh8lb" />,
    children: [{
      label: 'In-Person Book Clubs',
      to: '/events/book-clubs/in-person',
      icon: <UsersIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2562" data-mp="20pwg9ytwph4y" />
    }, {
      label: 'Virtual Book Clubs',
      to: '/events/book-clubs/virtual',
      icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2563" data-mp="8o3akdmjv1xu" />
    }, {
      label: 'Silent Book Clubs',
      to: '/events/silent-book-clubs',
      icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2564" data-mp="ilr6v7zt0hi4" />
    }]
  }, {
    label: 'Conferences & Festivals',
    icon: <BuildingIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2565" data-mp="mmjig7w5eyhk" />,
    children: [{
      label: 'Conventions & Festivals',
      to: '/events/conventions-festivals',
      icon: <BuildingIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2566" data-mp="wepj060guo8d" />
    }, {
      label: 'Reading Retreats',
      to: '/events/reading-retreats',
      icon: <CompassIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2567" data-mp="16cdfp1hmu5t6" />
    }, {
      label: 'Midnight Releases',
      to: '/events/midnight-releases',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2568" data-mp="2uvhnjpoe9eot" />
    }]
  }, {
    label: 'Workshops & Learning',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2569" data-mp="2qv7do1xhe44o" />,
    children: [{
      label: 'Writing Workshops',
      to: '/events/writing-workshops',
      icon: <PenToolIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2570" data-mp="2gwrq28xnxczx" />
    }, {
      label: 'Publishing Workshops',
      to: '/events/publishing-workshops',
      icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2571" data-mp="39k47y5svowmw" />
    }, {
      label: 'Craft Masterclasses',
      to: '/events/craft-masterclasses',
      icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2572" data-mp="2zszvbcqodnv8" />
    }]
  }, {
    label: 'Online Events',
    icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2573" data-mp="3si6so8ee87ew" />,
    children: [{
      label: 'Virtual Author Events',
      to: '/events/virtual-author-events',
      icon: <GlobeIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2574" data-mp="3d2jjd4xikjz0" />
    }, {
      label: 'Livestream Discussions',
      to: '/events/livestream-discussions',
      icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2575" data-mp="334c7v1lzuu4e" />
    }, {
      label: 'Online Workshops',
      to: '/events/online-workshops',
      icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2576" data-mp="3vrgefb0qjgia" />
    }]
  }, {
    label: 'Free Events',
    to: '/events/free',
    icon: <SparklesIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2577" data-mp="3lztvesi5od4z" />
  }, {
    label: 'View All Events',
    to: '/events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2578" data-mp="3qxlqfve3kfde" />
  }]
}];
export const readerListsSections: MenuSection[] = [{
  id: 'lists',
  label: 'Your Lists',
  icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2579" data-mp="ncy3n1jetmuz" />,
  children: [{
    label: 'My Bookshelf',
    to: '/my-bookshelf',
    icon: <BookIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2580" data-mp="232yzzmz36sym" />
  }, {
    label: 'My Tracker',
    to: '/my-tracker',
    icon: <BookmarkIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2581" data-mp="2gssno1yuv76r" />
  }, {
    label: 'New Release Tracker',
    to: '/new-release-tracker',
    icon: <TrendingUpIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2582" data-mp="1p1mobnqyldij" />
  }, {
    label: 'Wishlist',
    to: '/wishlist',
    icon: <HeartIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2583" data-mp="1k5ebih08hwej" />
  }, {
    label: 'Book Lists',
    to: '/reader/book-lists',
    icon: <LibraryIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2584" data-mp="1t3hub5ju4f2n" />
  }, {
    label: 'Reading History',
    to: '/reader/reading-history',
    icon: <BookOpenIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2585" data-mp="39kcb5y2hj7ek" />
  }, {
    label: 'Saved Events',
    to: '/saved-events',
    icon: <CalendarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2586" data-mp="226jqvtwuht4m" />
  }, {
    label: 'My Orders',
    to: '/my-orders',
    icon: <ClipboardListIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2587" data-mp="2730iwz760rmz" />
  }, {
    label: 'My Reviews',
    to: '/my-reviews',
    icon: <StarIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2588" data-mp="2g61isi5ftmi7" />
  }, {
    label: 'Messages',
    to: '/messages',
    icon: <MessageSquareIcon className="h-5 w-5 mr-3 text-gray-500" data-id="element-2589" data-mp="1jgu0dj047tii" />
  }]
}];